import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);
  const faqs = [{
    question: 'What types of appliances do you repair?',
    answer: 'We repair all major household appliances including washing machines, dryers, refrigerators, freezers, ovens, dishwashers, and more. Our engineers are trained to work with all popular brands available in the UK market.'
  }, {
    question: 'How quickly can you attend to a repair?',
    answer: 'We aim to arrange an engineer visit within 24-48 hours of your call. For urgent repairs, customers with prepaid service packages receive priority booking.'
  }, {
    question: 'Are your engineers qualified?',
    answer: 'Yes, all our engineers are fully qualified, insured, and experienced in repairing a wide range of appliances. They undergo regular training to stay up-to-date with the latest appliance technologies.'
  }, {
    question: 'What does a prepaid service package include?',
    answer: 'Our prepaid service packages include unlimited engineer callouts, diagnostics, all parts and labour costs, and priority booking. Specific details vary by package, so please check the package descriptions for more information.'
  }, {
    question: 'Do you offer any workmanship assurance on repairs?',
    answer: 'Yes, we stand behind our workmanship. If the same issue recurs within 90 days of our repair, we will return to address it at no additional cost.'
  }, {
    question: 'How do I book a repair visit?',
    answer: 'You can book a repair by calling our customer service team on 0800 055 4969 or by sending an email to support@maplewood-care.com. We will arrange for an engineer to visit at a time convenient for you.'
  }, {
    question: 'What areas do you service?',
    answer: 'We provide repair services across mainland UK. For remote areas such as the Scottish Highlands, there may be longer response times. Please contact us to check service availability in your specific location.'
  }, {
    question: 'Can I cancel my prepaid service package?',
    answer: 'Yes, you can cancel your prepaid service package at any time. Please refer to our Cancellation Policy for details on the process and any applicable refunds.'
  }];
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };
  return <div className="min-h-screen bg-white" data-id="element-377">
      <div className="bg-mwc-burgundy text-white py-12" data-id="element-378">
        <div className="container mx-auto px-4" data-id="element-379">
          <div className="flex flex-col md:flex-row items-center" data-id="element-380">
            <div className="md:w-2/3" data-id="element-381">
              <h1 className="text-3xl font-bold mb-4" data-id="element-382">
                Frequently Asked Questions
              </h1>
              <p className="text-lg max-w-2xl" data-id="element-383">
                Find answers to common questions about our appliance repair
                services, service plans, and more. If you can't find what you're
                looking for, please contact our customer service team.
              </p>
            </div>
            <div className="md:w-1/3 flex justify-center mt-8 md:mt-0" data-id="element-384">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bGue7ufgpqrtAUhjzWRpjA/Main.png" alt="Maplewood Care Mascot" className="max-w-full md:max-w-xs object-contain" data-id="element-385" />
            </div>
          </div>
        </div>
      </div>
      <div className="container mx-auto px-4 py-12" data-id="element-386">
        <div className="max-w-3xl mx-auto divide-y divide-gray-200" data-id="element-387">
          {faqs.map((faq, index) => <div key={index} className="py-6" data-id="element-388">
              <button className="flex justify-between items-center w-full text-left focus:outline-none" onClick={() => toggleFaq(index)} data-id="element-389">
                <h3 className="text-xl font-semibold text-mwc-burgundy" data-id="element-390">
                  {faq.question}
                </h3>
                {openIndex === index ? <ChevronUp className="flex-shrink-0 text-mwc-burgundy" data-id="element-391" /> : <ChevronDown className="flex-shrink-0 text-mwc-burgundy" data-id="element-392" />}
              </button>
              {openIndex === index && <div className="mt-4 text-gray-700" data-id="element-393">
                  <p data-id="element-394">{faq.answer}</p>
                </div>}
            </div>)}
        </div>
        <div className="max-w-3xl mx-auto mt-12 bg-mwc-lightpink p-6 rounded-lg" data-id="element-395">
          <h2 className="text-xl font-bold text-mwc-burgundy mb-4" data-id="element-396">
            Still Have Questions?
          </h2>
          <p className="text-gray-700 mb-6" data-id="element-397">
            If you couldn't find the answer to your question, our friendly
            customer service team is ready to help.
          </p>
          <div className="flex flex-col sm:flex-row gap-4" data-id="element-398">
            <a href="tel:08000554969" className="bg-mwc-burgundy hover:bg-mwc-darkburgundy text-white font-semibold px-6 py-3 rounded-md transition-colors duration-300 text-center" data-id="element-399">
              Call 0800 055 4969
            </a>
            <a href="mailto:support@maplewood-care.com" className="bg-mwc-green hover:bg-mwc-green/80 text-white font-semibold px-6 py-3 rounded-md transition-colors duration-300 text-center" data-id="element-400">
              Email Our Support Team
            </a>
          </div>
        </div>
      </div>
    </div>;
};
export default FAQ;